var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-panel-wrapper"},[_c('sb-panel',{staticClass:"sub-panel",attrs:{"variation":"sub"}},[_c('div',[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }